import React from 'react';

function QuestionIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#questionCircle_svg__a)" fill="none" stroke="#005f65">
        <circle cx="7" cy="7" r="5.5"></circle>
        <path strokeLinejoin="round" d="M6.99 10.24h.02v.02h-.02z"></path>
        <path
          strokeLinecap="round"
          d="M5.5 5.25a1.5 1.5 0 1 1 2.428 1.179C7.494 6.77 7 7.198 7 7.75"
        ></path>
      </g>
      <defs>
        <clipPath id="questionCircle_svg__a">
          <path fill="#fff" d="M0 0h14v14H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default QuestionIcon;
